export default [
  'BOTSearchTiresBySizePanel'
]

/*
Appears on:
/tires/winter-snow
*/
